import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss'],
})
export class AuthErrorComponent implements OnInit {
  supportEmail = 'EWRSfeedback@ontario.ca';
  errorId: string = '';

  constructor(private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    const errorDetails = navigation?.extras?.state?.['errorDetails'];

    if (errorDetails && (errorDetails.status !== undefined || errorDetails.timestamp)) {
      this.errorId = this.generateErrorId(errorDetails);
    } else {
      this.errorId = `ERR-${Date.now()}`;
    }
  }

  ngOnInit(): void {
    const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    const isPageReload = navEntry?.type === 'reload' || performance.navigation?.type === 1;

    if (isPageReload) {
      this.router.navigate(['/home']);
      return;
    }
  }

  private generateErrorId(errorDetails: any): string {
    const status = errorDetails?.status ?? 0;
    const timestamp = errorDetails?.timestamp ?? Date.now();
    return `ERR-${status}-${timestamp}`;
  }

  close(): void {}
}
